const getSubfragm = (_len, _desiredCenter, _desiredSubfragmLen) => {
    // Определить фрагмент определенной длины из внешнего фрагмента по желаемому положению центра субфрагмента

    if (_desiredCenter < 0 || _desiredCenter >= _len) {
        return undefined;
    }

    _desiredCenter += 0.5; // 0.5 т.к _desiredCenter это индекс ТОЧКИ, без учета её длины

    const fragmLen = Math.min(_desiredSubfragmLen, _len);
    let start_pnt = 0;
    if (_desiredCenter && _len > fragmLen) {
        const halfWhiteSpace = fragmLen / 2; // Желательное "свободное место" ВНУТРИ экспортируемого фрагмента перед комплексом
        start_pnt = Math.ceil(_desiredCenter - halfWhiteSpace);
        if (start_pnt <= 0) {
            start_pnt = 0;
        } else if (_desiredCenter + halfWhiteSpace >= _len) {
            // Если фргамент с желательным пустым местом ПОСЛЕ комплекса вылезает за пределы сигнала
            start_pnt = _len - fragmLen;
        }
    }

    return {
        start: start_pnt,
        length: fragmLen
    };
};

export default getSubfragm;
